import { render, staticRenderFns } from "./ModalDuplicar.vue?vue&type=template&id=a8e73fae&"
import script from "./ModalDuplicar.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicar.vue?vue&type=script&lang=js&"
import style0 from "./ModalDuplicar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports